import { z } from 'zod';
export const healthOutputSchema = z.object({
    status: z.literal('ok'),
    db: z.boolean(),
    time: z.string().datetime(),
});
//# sourceMappingURL=health.schemas.js.map